const ITEM_STORAGE = {
  LANG: "lang",
  USERNAME: "username",
  ROLES: "roles",
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  EXPIRES_DATE: "expiresDate",
  USER_INFO: "userInfo",
};

const LANGUAGE_OPTION = {
  ENGLISH: "en",
  JAPAN: "ja",
};

const HTTP_CODE = {
  SUCCESS: "API_200",
  BAD_REQUEST: "API_304",
  NOT_POUND: "API_404",
};

const DEVICE_TYPE = {
  DESKTOP: "desktop",
  MOBILE: "mobile",
  TABLET: "tablet",
};

const STATUS_ENUM = {
  INACTIVE: 1,
  ACTIVE: 2,
  DELETE: 3,
};

const HISTORY_ACTION_ENUM = {
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
  APPROVE: 4,
  REJECT: 5,
};

const HISTORY_TYPE_ENUM = {
  REGISTRATION: 1,
  LICENSE: 2,
};

const CUSTOMER_NAME_TYPE_ENUM = {
  FREE_TRIAL: 1,
  APPLY_LICENSE: 2,
};

const MONTH_ENUM = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};

const LICENSE_REGISTRATION_ENUM = {
  NEW: 1,
  ACTIVE: 2,
  ALMOST_EXPIRED: 3,
  EXPIRED: 4,
  OVERDUE_RELEASE: 5,
};

const LICENSE_ENUM = {
  EXPIRED: 1,
  ACTIVE: 2,
  ALMOST_EXPIRED: 3,
};

const SENT_MAIL_ENUM = {
  NOT_YET: 1,
  SENT: 2,
};

const STATUS_PAGE_MAP = {
  DETAIL: 1,
  CREATE: 2,
  EDIT: 3,
};

const ROLE_ENUM = {
  USER: 1,
  ADMIN: 2,
};

const SYSTEM_ROLE = {
  USER: "USER",
  ADMIN: "ADMIN",
};

const REGEX = {
  ALPHA_NUMERIC: /^[a-zA-Z0-9]+$/, // Only allows alphanumeric characters
  NUMERIC: /^\d+$/, // Only allows numeric characters
  VERSION: /^\d+\.\d+\.\d+$/,
  MAC_ADDRESS:
    /^(?:[0-9A-Fa-f]{2}([-:])[0-9A-Fa-f]{2}(\1)[0-9A-Fa-f]{2}(\1)[0-9A-Fa-f]{2}(\1)[0-9A-Fa-f]{2}(\1)[0-9A-Fa-f]{2}|[0-9A-Fa-f]{4}(\.)[0-9A-Fa-f]{4}(\.)[0-9A-Fa-f]{4}|[0-9A-Fa-f]{12})$/,
};

export {
    CUSTOMER_NAME_TYPE_ENUM, DEVICE_TYPE, HISTORY_ACTION_ENUM, HISTORY_TYPE_ENUM, HTTP_CODE, ITEM_STORAGE,
    LANGUAGE_OPTION, LICENSE_ENUM, LICENSE_REGISTRATION_ENUM, MONTH_ENUM, REGEX, ROLE_ENUM, SENT_MAIL_ENUM, STATUS_ENUM, STATUS_PAGE_MAP, SYSTEM_ROLE
};

